import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

export enum ID_NUMBERS_COMPARENTI {
  ID_COMPARENTE1 = '1',
  ID_COMPARENTE2 = '2',
}

const numbers = Object.freeze([
  {
    id: ID_NUMBERS_COMPARENTI.ID_COMPARENTE1,
    value: '1',
  },
  {
    id: ID_NUMBERS_COMPARENTI.ID_COMPARENTE2,
    value: '2',
  },
]);

export enum ID_NUMBERS_WITNESSES {
  ID_2 = '2',
  ID_3 = '3',
  ID_4 = '4',
}

const numbers2 = Object.freeze([
  {
    id: ID_NUMBERS_WITNESSES.ID_2,
    value: '2',
  },
  {
    id: ID_NUMBERS_WITNESSES.ID_3,
    value: '3',
  },
  {
    id: ID_NUMBERS_WITNESSES.ID_4,
    value: '4',
  },
]);

export enum ID_NUMBERS_HOLDERS {
  ID_1 = '1',
  ID_2 = '2',
  ID_3 = '3',
  ID_4 = '4',
  ID_5 = '5',
  ID_6 = '6',
  ID_7 = '7',
  ID_8 = '8',
  ID_9 = '9',
  ID_10 = '10',
  ID_11 = '11',
  ID_12 = '12',
  ID_13 = '13',
  ID_14 = '14',
  ID_15 = '15',
  ID_16 = '16',
  ID_17 = '17',
  ID_18 = '18',
  ID_19 = '19',
  ID_20 = '20',
}

const numbers20 = Object.freeze([
  {
    id: ID_NUMBERS_HOLDERS.ID_1,
    value: '1',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_2,
    value: '2',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_3,
    value: '3',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_4,
    value: '4',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_5,
    value: '5',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_6,
    value: '6',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_7,
    value: '7',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_8,
    value: '8',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_9,
    value: '9',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_10,
    value: '10',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_11,
    value: '11',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_12,
    value: '12',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_13,
    value: '13',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_14,
    value: '14',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_15,
    value: '15',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_16,
    value: '16',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_17,
    value: '17',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_18,
    value: '18',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_19,
    value: '19',
  },
  {
    id: ID_NUMBERS_HOLDERS.ID_20,
    value: '20',
  },
]);

interface ListNumberProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  isSmallSize?: boolean;
  label?: string;
  isNumber2?: boolean;
  isNumber20?: boolean;
}

const ListNumberComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
  label = 'Numero comparenti',
  isNumber2 = false,
  isNumber20 = false,
}: ListNumberProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="number-label">
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId="number-label"
        id="number"
        name="number"
        value={value}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        {(isNumber20 ? numbers20 : isNumber2 ? numbers2 : numbers).map((number: ItemVM) => (
          <MenuItem key={number.id} value={number.id}>
            {number.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListNumberComponent.displayName = 'List Number component';

const ListNumber = memo(ListNumberComponent);

export default ListNumber as typeof ListNumberComponent;
